import validateJs from '../../../utils/validate';

const constraints = {
  vendorId: {
    presence: { allowEmpty: false }
  }
};

export const validate = (values) => {
  let errors = {};
  const result = validateJs.validate(values, constraints);
  if (result) {
    Object.keys(result).forEach((key) => {
      errors[key] = result[key][0];
    });
  }
  return errors;
};
